import { map, pick, omit, trimStart } from 'lodash';
import { push } from '../services/router-utils';
import { setQueryParams } from './sdk-query-params';
import { parseGetParam } from './parse-get-param';
import Wix from './wix-sdk-polyfill';
import { isInSite, isInEditor } from './view-mode';

const ROUTING_PARAMS = ['sort', 'name', 'query', 'redirect', 'page'];

export default function listenToHistoryStateChange(history, store) {
  const wasRedirected = parseGetParam('redirected') === 'true';
  // State changes triggered by app should be ignored to prevent an infinite loop
  let isInitialLoad = true;
  let lastState = null;

  const hasChanged = newState => lastState !== newState;

  history.listen(location => {
    const query = location.query || {};
    if (isInitialLoad) {
      setQueryParams(omit(query, ROUTING_PARAMS));
    }
    const queryParams = map(pick(query, ROUTING_PARAMS), (value, name) => `${name}=${encodeURIComponent(value)}`).join(
      '&'
    );
    const search = queryParams ? `?${queryParams}` : '';
    const pathname = trimStart(location.pathname, '/') + search || './';
    const isInitialLoadAfterRedirect = !wasRedirected && isInitialLoad;

    if (isInSite() && hasChanged(pathname) && !isInitialLoadAfterRedirect) {
      Wix.replaceSectionState(pathname);
      lastState = pathname;
    }

    isInitialLoad = false;
  });

  Wix.addEventListener(Wix.Events.STATE_CHANGED, ({ newState }) => {
    if (newState === '') {
      newState = './';
    }

    if (isInEditor() || !hasChanged(newState)) {
      return;
    }
    lastState = newState;

    const pathname = `/${newState.replace(/\.\//, '')}`;
    store.dispatch(push(pathname));
  });

  Wix.addEventListener(Wix.Events.EDIT_MODE_CHANGE, () => {
    lastState = null;
  });
}



// WEBPACK FOOTER //
// ./app/services/listen-to-history-state-change.js